import React, {useEffect, useState} from 'react';
import {Button, CircularProgress, MenuItem} from "@mui/material";
import BBIconEdit from "../../../assets/bbCustomIcons/BBIconEdit";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
// import Tooltip from "@material-ui/core/Tooltip";
import {Select, TextField, withStyles} from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import NewBRShareInvitationForm from "./NewBRShareInvitationForm";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import {useDispatch, useSelector} from "react-redux";
import {bbDictionaryOfBreachRiskLevels, bbShortenString} from "../../../util/bbHelpers";
import IntlMessages from "../../../util/IntlMessages";
import {useForm} from "react-hook-form";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {Col, Row} from "reactstrap";
import {updateBRBusinessShareAccessLevel} from "../../../actions";

const UpdateApprovedShareAccessLevelDialog = ({share=null})=>{

    // console.log("THIS IS THE SHARE BEING PASSED TO THIS THING TO UPDATE MAYBE", share)
    const dispatch = useDispatch();

    const {loadingUpdateBRBusinessShare, loadingUpdateBRBusinessShareError } = useSelector(({breachrisk}) => breachrisk);
    const {didJustCreateNewShare } = useSelector(({breachrisk}) => breachrisk.appMisc);

    const [open, setOpen] = useState(false);
    const [dataLevel, setDataLevel] = useState(share && share.dataLevelId ? share.dataLevelId : 2);

    const accessLevelArray = bbDictionaryOfBreachRiskLevels
    && Object.values(bbDictionaryOfBreachRiskLevels)
        ? Object.values(bbDictionaryOfBreachRiskLevels) : [];
    const { register, handleSubmit, errors } = useForm();


    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const onSubmit = () =>{
        console.log("Gonna send this on to the action", "customerId", share.customerId, "shrre.id", share.id, "dataLevel", dataLevel)
        dispatch(updateBRBusinessShareAccessLevel(share.customerId, share.id, dataLevel))
        // handleClose();
    }

    useEffect(() => {
        if(didJustCreateNewShare) {
            handleClose()
        }
        // setLocalLoading(false);
    }, [didJustCreateNewShare]);

    const DialogTitle = (props) => {
        const { children, classes, onClose, ...other } = props;
        return (
            <MuiDialogTitle disableTypography className={"m-0 align-content-center"}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={"close m-0 align-content-center"} style={{ right: "1em", top: "1em", position: "absolute"}} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    };

    // console.log("this is the value of dataLevel,", dataLevel)
    return(
        <div id={"tourUpdateApprovedShare"}>
            <Tooltip title={``}>
                <Button onClick={handleClickOpen}>
                    {share && share.dataLevelName ? share.dataLevelName : 'N/A'}&nbsp;{share && share.dataLevelName ? <BBIconEdit style={{fontSize: "1.25em"}}/> : null}
                </Button>
            </Tooltip>

            <Dialog
                fullWidth={true}
                maxWidth={"sm"}
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    Update Sharing Relationship {share && share.companyName ? `with ${share.companyName}` : null}
                </DialogTitle>
                <DialogContent>
                    { loadingUpdateBRBusinessShare[share.id] || loadingUpdateBRBusinessShareError[share.id]
                        ? <div className={"text-center m-5 p-8 border-2"}>
                                <CircularProgress/>
                            </div>
                        :<div className={"border-2 p-3 "}>
                        <DialogContentText>
                            <p>
                                If you'd like to adjust the amount of information {share && share.companyName ? share.companyName : "this company"} sees from you, you can select a new access level below.
                            </p>
                            {/*<p>*/}
                            {/*    All information you share across the BreachBits platform remains secure and limited to those companies that you select.*/}
                            {/*    When sharing information with other companies, make sure what you share matches up with your relationship with that company. */}
                            {/*</p>*/}
                        </DialogContentText>
                        <br/>
                        <Row>
                            <Col className={""}>
                                <Select
                                    labelId="appModule.newBRBusinessShare.dataLevel"
                                    id="dataLevel"
                                    name="dataLevel"
                                    value={dataLevel}
                                    onChange={(event) => setDataLevel(event.target.value)}
                                    // displayEmpty
                                    className={"mt-1 my-sm-3"}
                                    style={{width: "90%"}}
                                >
                                    {accessLevelArray &&
                                        accessLevelArray.map((option, i)=>{
                                                return  <MenuItem key={i} value={option.value} className={"d-block p-1"}>
                                                    <Tooltip title={option.description}>
                                                        <span>{option.icon}&nbsp;{option.label}</span>
                                                    </Tooltip>
                                                </MenuItem>
                                            }
                                        )
                                    }
                                </Select>&nbsp;<Tooltip link={"https://support.breachbits.com/knowledge/requesting-access"} heading={"Sharing Details"} title={" "}>
                                <InfoSharpIcon fontSize={"16px"}/>
                            </Tooltip>
                                <div style={{width: "100%"}} className="m-0 p-0 d-flex align-items-center justify-content-between row">
                                    {(dataLevel === 3 || dataLevel === 4)
                                        &&
                                        <p className={"m-0 p-0 text-red"}><small>
                                            ** Ensure this is the appropriate access level to give to this company.
                                        </small>
                                        </p>}
                                </div>
                                <div style={{width: "100%"}} className="m-0 p-0 d-flex align-items-center justify-content-between row">
                                    <div className={"col col-12 m-0 p-0"}>
                                        <p className={` m-0 p-0`}>
                                            <small>
                                                {bbDictionaryOfBreachRiskLevels[dataLevel].description}
                                            </small>
                                        </p>
                                    </div>
                                </div>

                            </Col>

                        </Row>
                        <Row>
                            <Col>
                                <Button onClick={handleSubmit(onSubmit)}
                                        variant={"contained"}
                                        // color={"secondary"}
                                        className={"float-right"}>
                                    Confirm
                                </Button>
                            </Col>
                        </Row>

                    </div>}

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Done
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default UpdateApprovedShareAccessLevelDialog